// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/resort-background.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/earlyaccess/notosanskr.css);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html, body, #root {
  font-family:'Noto Sans CJK KR', Noto Sans KR, sans-serif !important;
  font-weight: 500;
  margin: 0;
  background-color: #fff;
}
  @media (max-width: 320px) {
    html, body, #root {
      font-size: 9px;
    }
  }
  @media (max-width: 280px) {
    html, body, #root {
      font-size: 8px;
    }
  }

p {
  margin: 0;
}

*, *::before, *::after {
  box-sizing: border-box;
}

:focus-visible {
  outline: medium none invert;
  outline: initial;
}

/* const display */
.d-block { display: block !important; }

/* const background */
.bc-yellow { background-color: #BD9A1D !important; }
.bc-gray { background-color: #bdbdbd !important; }

/* const font */
.fw-default { font-family:'Noto Sans CJK KR', Noto Sans KR, sans-serif }
.fs-12 { font-size: 12px !important;}
.fs-13 { font-size: 13px !important;}
.fw-500 { font-weight: 500 !important; }
.fw-700 { font-weight: 700 !important; }
.c-red { color: #ff0000 !important;}
.ws-pl { white-space: pre-line; }

/* const height/width */
.h-40 { height: 40px !important; }
.h-full { height: 100% !important; }
.w-unset { width: auto !important; width: initial !important; }

/* const position */
.p-relative { position: relative !important; }
.p-absolute { position: absolute !important; }
.top-6 { top: 6px !important; }
.right-0 { right: 0 !important; }

/* const margin */
.mt-1 { margin-top: 1px !important; }
.mt-4 { margin-top: 4px !important; }
.mt-5 { margin-top: 5px !important; }
.mt-8 { margin-top: 8px !important; }
.mt-9 { margin-top: 9px !important; }
.mt-10 { margin-top: 10px !important; }
.mt-12 { margin-top: 12px !important; }
.mt-15 { margin-top: 15px !important; }
.mt-17 { margin-top: 17px !important; }
.mt-18 { margin-top: 18px !important; }
.mt-20 { margin-top: 20px !important; }
.mt-24 { margin-top: 24px !important; }
.mt-27 { margin-top: 27px !important; }
.mt-28 { margin-top: 28px !important; }
.mt-30 { margin-top: 30px !important; }
.mt-35 { margin-top: 35px !important; }
.mt-40 { margin-top: 40px !important; }
.mt-52 { margin-top: 52px !important; }
.mr-4 { margin-right: 4px !important; }
.mr-8 { margin-right: 8px !important; }
.mr-20 { margin-right: 20px !important; }
.mr-23 { margin-right: 23px !important; }
.mr-30 { margin-right: 30px !important; }
.mr-50 { margin-right: 50px !important; }
.mb-2 { margin-bottom: 2px !important; }
.mb-8 { margin-bottom: 8px !important; }
.mb-10 { margin-bottom: 10px !important; }
.mb-12 { margin-bottom: 12px !important; }
.mb-17 { margin-bottom: 17px !important; }
.mb-18 { margin-bottom: 18px !important; }
.mb-20 { margin-bottom: 20px !important; }
.mb-25 { margin-bottom: 25px !important; }
.mb-28 { margin-bottom: 28px !important; }
.mb-35 { margin-bottom: 35px !important; }
.mb-40 { margin-bottom: 40px !important; }
.mb-60 { margin-bottom: 60px !important; }
.ml-20 { margin-left: 20px !important; }
.ml-23 { margin-left: 23px !important; }
.ml-30 { margin-left: 30px !important; }
.ml-50 { margin-left: 50px !important; }

/* const padding */
.pt-40 { padding-top: 40px !important; }
.pr-0 { padding-right: 0 !important; }
.pr-20 { padding-right: 20px !important; }
.pr-30 { padding-right: 30px !important; }
.pb-40 { padding-bottom: 40px !important; }
.pb-78 { padding-bottom: 78px !important; }
.pb-100 { padding-bottom: 100px !important; }
.pb-120 { padding-bottom: 120px !important; }
.pl-0 { padding-left: 0 !important; }
.pl-20 { padding-left: 20px !important; }
.pl-30 { padding-left: 30px !important; }

/* const image */
img {
  vertical-align: middle;
  border-style: none;
}

/* commons component */
.horizontal-line {
  height: 1px;
  background-color: #ebebeb;
}
.horizontal-box {
  height: 10px;
  background-color: #f4f4f4;
}
img.resort-logo {
  width: 83px;
}
img.resort-sub-logo {
  width: 100%;
  max-width: 450px;
}
img.tip-icon {
  width: 14px;
  height: 14px;
  object-fit: contain;
}
img.checkbox {
  width: 18px;
  height: 18px;
}
img.arrow-right {
  position: absolute;
  right: 0;
  width: 18px;
  height: 18px;
  object-fit: contain;
}
img.close-button {
  width: 24px;
  height: 24px;
  object-fit: contain;
}
img.password-view {
  width: 17px;
  height: 17px;
}
img.important-notice {
  width: 22px;
  height: 25px;
}
img.resort-map {
  width: 100%;
}
img.search {
  width: 13.67px;
  height: 12.15px;
}
img.info-notice {
  width: 13px;
  height: 11px;
}
img.safari-setup {
  width: 100%;
}

/* button */
button.basic-button {
  width: 100%;
  height: 48px;
  padding: 0;
  background-color: #000;
  border: medium none currentColor;
  border: initial;
  border-radius: 8px;
  font-size: 15px;
  font-style: normal;
  color: #fff;
}
  button.basic-button:disabled {
    background-color: #f4f4f4;
    color: #000;
  }
/* checkbox */
.agree-checkbox-container {
  display: flex;
  position: relative;
  line-height: 1;
}
  .agree-checkbox-container .agree-checkbox-text {
    width: calc(100% - 50px);
    font-size: 14px;
    font-weight: 350;
    font-style: normal;
    line-height: 1.43;
    letter-spacing: -0.4px;
    color: #000;
    word-break: keep-all;
  }
    @media (max-width: 320px) {
      .agree-checkbox-container .agree-checkbox-text {
        font-size: 11px;
      }
    }
/* PDF */
.react-pdf__Page__canvas {
  width: 100% !important;
  height: auto !important;
  height: initial !important;
}
.react-pdf__Page__svg,
.react-pdf__Page__svg > svg,
.react-pdf__Page__textContent {
  width: 100% !important;
  height: 100% !important;
}
.react-pdf__Page {
  border-bottom: 1px dotted;
}

/* modal */
.modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 998;
}
  .modal .modal-body {
    position: fixed;
    left: 50%;
    top: 50%;
    width: calc(100% - 40px);
    max-height: 80%;
    overflow: scroll;
    /* height: 400px; */
    /* margin: 0 20px 0; */
    padding: 16px 20px;
    border-radius: 24px;
    box-shadow: 4px 4px 16px 0 rgb(0 0 0 / 10%);
    background-color: #fff;
    /* align-items: center; */
    transform: translate(-50%, -50%);
  }
    .modal .modal-body.full {
      width: 100%;
      height: 100%;
      border-radius: 0;
      border-radius: initial;
      padding: 0;
    }
    .modal .modal-body.x-large {
      height: 70%;
      border-radius: 0;
      border-radius: initial;
      padding: 0;
    }
    .modal .modal-body.large {
      height: 60%;
      border-radius: 0;
      border-radius: initial;
      padding: 0;
    }
    @media (min-width: 550px) {
      .modal .modal-body {
        width: calc(100% - 248px);
      }
    }
    @media (min-width: 720px) {
      .modal .modal-body {
        width: calc(100% - 356px);
      }
    }
    .modal .modal-body .modal-title-container {
      width: 100%;
      height: 52px;
      position: fixed;
      background-color: #fff;
      border-bottom: 1px solid #ebebeb;
      z-index: 999;
    }
      .modal .modal-body .modal-title-container .modal-title {
        display: block;
        height: 52px;
        font-size: 16px;
        font-stretch: normal;
        font-style: normal;
        line-height: 52px;
        letter-spacing: -0.4px;
        text-align: center;
        color: #000;
      }
    .modal .modal-body .modal-content-container {
      height: 100%;
      overflow: scroll;
    }
    .modal .modal-body.exist-title .modal-content-container {
      height: calc(100% - 52px);
      overflow: scroll;
    }
    .modal .modal-body .close-button-container {
      position: fixed;
      left: 18px;
      top: 18px;
      z-index: 1000;
    }
      .modal .modal-body.x-large .close-button-container,
      .modal .modal-body.large .close-button-container,
      .modal .modal-body.full .close-button-container {
        left: 16px;
        top: 14px;
      }

/* pc page */
.on-pc-icon {
  text-align: center;
  font-size: 100px;
  color: #faad14;
}
.on-pc-status-code {
  display: block;
  margin: 14px 0;
  font-size: 22px;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: -0.4px;
  text-align: center;
  color: #000;
}
.on-pc-status-message {
  display: block;
  margin: 0 0 20px;
  font-size: 16px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: -0.4px;
  text-align: center;
  word-break: keep-all;
  color: #000;
}

/* 404 page */
.not-found-icon {
  text-align: center;
  font-size: 100px;
  color: #faad14;
}
.not-found-code {
  display: block;
  margin: 14px 0;
  font-size: 22px;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: -0.4px;
  text-align: center;
  color: #000;
}
.not-found-message {
  display: block;
  margin: 0 0 20px;
  font-size: 16px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: -0.4px;
  text-align: center;
  word-break: keep-all;
  color: #000;
}

/* spinner */
.spinner-container {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 1999;
}
.spinner-container .spinner-text {
  position: fixed;
  top: 50%;
  width: 100%;
  color: #8fb0cf;
  font-size: 16px;
  z-index: 2000;
  display: block;
  text-align: center;
}

/* safari setup page */
.safari-setup-title {
  font-size: 15px;
  font-weight: 500;
  word-break: keep-all;
  margin: 15px 0 0;
}
.safari-setup-description-title {
  margin: 15px 0 0;
  font-size: 15px;
  font-weight: 700;
  word-break: keep-all;
}
.safari-setup-description-content {
  display: block;
  font-size: 14px;
  font-weight: 400;
  word-break: keep-all;
}
.info-notice-container {
  display: flex;
  margin: 2px 0 0;
}
  .info-notice-container .info-notice-text {
    display: block;
    color: #AB8524;
    font-size: 12px;
    font-weight: 400;
    word-break: keep-all;
  }

/* checkin before page */
.result-background-container {
  padding: 0 22px 0 18px;
  text-align: center;
}
.checkin-before-title {
  font-size: 24px;
  font-style: normal;
  color: #000;
  margin: 0 0 20px;
}
.checkin-before-desc {
  display: block;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  color: #000;
  margin: 0 0 74px;
}
@media (max-width: 320px) {
  .checkin-before-title {
    font-size: 22px;
  }
  .checkin-before-desc {
    font-size: 12px;
  }
}

/* booking details page */
.booking-background-container {
  position: relative;
  height: 216px;
  width: 100%;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center top / cover no-repeat;
}
  .booking-background-container .resort-logo-container {
    text-align: right;
  }
  .booking-background-container .welcome-message {
    position: absolute;
    bottom: 65px;
    left: 21px;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    color: #fff;
  }
.booking-details-card-container {
  position: absolute;
  top: 196px;
  width: 100%;
  padding: 20px 0 78px;
  border-radius: 24px;
  background-color: #fff;
}
  .booking-details-card-container .resort-name,
  .inhouse-details-card-container .resort-name {
    font-size: 18px;
    font-style: normal;
    line-height: 1.5;
    color: #000;
    padding: 0 30px 0;
  }
  .booking-details-card-container .roomtype-name,
  .inhouse-details-card-container .roomtype-name {
    display: block;
    font-size: 14px;
    font-weight: 400;
    font-style: normal;
    line-height: 1.43;
    color: #000;
    margin: 8px 0 0;
    padding: 0 30px 0;
  }
  .booking-details-card-container .period {
    display: block;
    font-size: 12px;
    font-weight: 350;
    font-style: normal;
    line-height: 1.43;
    color: #000;
    margin: 5px 0 0;
    padding: 0 30px 0;
  }
  .booking-details-card-container .amount {
    display: block;
    font-size: 15px;
    font-weight: 500;
    text-align: right;
    padding: 0 30px;
    margin: 10px 0 0;
  }
  .booking-details-card-container .booking-details-title {
    font-size: 16px;
    font-style: normal;
    color: #000;
    padding: 0 30px 0;
  }
  .booking-details-card-container .booking-details-info {
    margin: 10px 0 0;
    font-size: 14px;
    color: #000;
    padding: 0 30px 0;
  }
    .booking-details-card-container .booking-details-info .booking-details-info-label {
      display: inline-block;
      width: 35%;
      font-weight: 400;
    }
    .booking-details-card-container .booking-details-info .booking-details-info-value {

    }
    .booking-details-card-container .certification-notice {
      display: flex;
      margin: 8px 30px;
    }
    .booking-details-card-container .certification-notice .certification-notice-text {
      display: block;
      font-weight: 350;
      font-size: 12px;
      color: #FF4129;
      word-break: keep-all;
    }
/* room select before page */
.room-select-before-container {
  margin: 0 30px;
  padding: 47px 0 0;
}
  .room-select-before-container .resort-name {
    font-size: 18px;
    font-style: normal;
    line-height: 1.5;
    color: #000;
  }
  .room-select-before-container .roomtype-name {
    display: block;
    font-size: 14px;
    font-weight: 400;
    font-style: normal;
    line-height: 1.43;
    color: #000;
    margin: 12px 0 0;
  }
  .room-select-before-container .period {
    display: block;
    font-size: 12px;
    font-weight: 350;
    font-style: normal;
    line-height: 1.43;
    color: #000;
    margin: 7px 0 0;
  }
  .room-select-before-container .amount {
    display: block;
    font-size: 15px;
    font-weight: 500;
    text-align: right;
    padding: 0 30px;
    margin: 10px 0 0;
  }
  .room-select-before-container .booking-details-title {
    font-size: 16px;
    font-style: normal;
    color: #000;
  }
  .room-select-before-container .booking-details-info {
    margin: 20px 0 0;
    font-size: 14px;
    color: #000;
  }
    .room-select-before-container .booking-details-info .booking-details-info-label {
      display: inline-block;
      width: 35%;
      font-weight: 400;
    }
    .room-select-before-container .booking-details-info .booking-details-info-value {

    }

/* terms of use list page */
.terms-of-use-list-title {
  margin: 0 0 6px;
  font-size: 24px;
  font-style: normal;
  line-height: 1.42;
  color: #000;
}
.terms-of-use-list-description {
  display: block;
  margin: 0 0 28px;
  font-size: 13px;
  font-weight: 350;
  font-style: normal;
  line-height: 1.38;
  letter-spacing: -0.4px;
  color: #000;
}

/* terms of use details page */
.terms-of-use-details-title {
  margin: 26px 30px 0;
  font-size: 16px;
}
.terms-of-use-details-description {
  display: block;
  margin: 17px 30px 0;
  font-size: 14px;
  font-weight: 350;
  white-space: break-spaces;
  word-break: keep-all;
}

/* room list page */
.room-list-title {
  margin: 28px 30px 0 30px;
  font-size: 18px;
  font-weight: 500;
}
.map-zoom-in-button {
  line-height: 10px;
  margin-top: 4px;
  text-align: center;
}
.map-zoom-in-text {
  font-size: 12px;
  font-weight: 400;
}
.room-list.roomtype-name {
  margin: 18px 30px 0;
  font-size: 18px;
  font-weight: 700;
}
.room-list-description {
  display: block;
  margin: 0 30px;
  font-size: 12px;
  font-weight: 400;
}
.facility-list-title {
  margin: 22px 30px 0;
  font-size: 12px;
  font-weight: 400;
}
.facility-list-data-container {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-auto-rows: minmax(33px, auto);
  grid-column-gap: 13px;
  column-gap: 13px;
  grid-row-gap: 10px;
  row-gap: 10px;
  margin: 10px 30px 0;
  overflow-x: scroll;
  white-space: nowrap;
}
  .facility-list-data-container .facility-list-value {
    display: inline-block;
    text-align: center;
    border: 1px solid #000;
    border-radius: 10px;
    font-size: 12px;
    font-weight: 400;
    line-height: 28px;
  }
  .facility-list-data-container .facility-list-value.selected {
    background-color: #666;
    color: #fff;
  }

/* room select page */
.room-select-body-container {
  width: 100%;
  padding: 4px 0 9px;
  border-radius: 24px;
  background-color: #fff;
}
  .room-select-body-container .resort-name {
    font-size: 18px;
    font-style: normal;
    line-height: 1.5;
    color: #000;
    padding: 0 20px 0;
  }
  .room-select-body-container .roomtype-name {
    display: block;
    font-size: 14px;
    font-weight: 400;
    font-style: normal;
    line-height: 1.43;
    color: #000;
    margin: 12px 0 0;
    padding: 0 20px 0;
  }
  .room-select-body-container .room-info {
    display: flex;
    padding: 0 20px;
    margin: 4px 0 0;
    color: #000;
  }
    .room-select-body-container .room-info .room-name {
      display: block;
      font-size: 24px;
      font-weight: 500;
      font-style: normal;
      margin: 0 15px 0 0;
    }
    .room-select-body-container .room-info .building-name {
      display: block;
      font-size: 20px;
      font-weight: 500;
      line-height: 1.65;
    }
  .room-select-body-container .period-info {
    margin: 3px 0 0;
    font-size: 12px;
    color: #000;
    padding: 0 20px 0;
  }
    .room-select-body-container .period-info .period-info-label {
      display: inline-block;
      width: 20%;
      font-weight: 350;
    }
    .room-select-body-container .period-info .period-info-value {

    }
    .room-select-body-container .amount {
      display: block;
      font-size: 15px;
      font-weight: 500;
      padding: 0 20px;
      margin: 3px 0 0;
    }

/* payment success page */
.payment-success-details-info {
  margin: 5px 0 0 3px;
  font-size: 12px;
  color: #000;
}
  .payment-success-details-info .payment-success-details-info-label {
    display: inline-block;
    width: 25%;
    font-weight: 700;
  }
  .payment-success-details-info .payment-success-details-info-value {
    font-weight: 400;
  }

/* inhouse details page */
.inhouse-details-card-container {
  position: absolute;
  top: 196px;
  width: 100%;
  padding: 30px 0 78px;
  border-radius: 24px;
  background-color: #fff;
}
  .inhouse-details-card-container .room-info {
    display: flex;
    padding: 0 30px;
    margin: 4px 0 0;
    color: #000;
  }
    .inhouse-details-card-container .room-info .room-name {
      display: block;
      font-size: 24px;
      font-weight: 500;
      font-style: normal;
      margin: 0 15px 0 0;
    }
    .inhouse-details-card-container .room-info .building-name {
      display: block;
      font-size: 20px;
      font-weight: 500;
      line-height: 1.65;
    }
  .inhouse-details-card-container .period-info {
    margin: 3px 0 0;
    font-size: 12px;
    color: #000;
    padding: 0 30px 0;
  }
    .inhouse-details-card-container .period-info .period-info-label {
      display: inline-block;
      width: 20%;
      font-weight: 350;
    }
    .inhouse-details-card-container .period-info .period-info-value {

    }
  .inhouse-details-card-container .pincode-info {
    padding: 0 30px 0;
  }
    .inhouse-details-card-container .pincode-info .pincode-info-label {
      font-size: 14px;
      font-weight: 400;
    }
    .inhouse-details-card-container .pincode-info .pincode-info-value {
      font-size: 20px;
      font-weight: 700;
    }

/* checkout request page */
/* payment fail page */
.room-select-title,
.checkout-request-title,
.payment-success-title,
.payment-fail-title {
  font-size: 18px;
  font-weight: 500;
  margin: 2px 0 0;
}
.checkout-request-description,
.payment-fail-description {
  display: block;
  font-size: 14px;
  font-weight: 400;
  color: #000;
  margin: 20px 0 0;
}
.checkout-agree-checkbox-container {
  margin: 10px 0 0;
}
.checkout-agree-checkbox-container .agree-checkbox-text {
  font-size: 14px;
  font-weight: 400;
}

/* checkout success page */
.checkout-success-title {
  font-size: 18px;
  font-style: normal;
  color: #000;
  margin: 0 0 14px;
}
.checkout-success-desc {
  display: block;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  word-break: keep-all;
  color: #000;
}
.checkout-success-desc-notice {
  display: block;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  color: #ff0000;
}
  @media (max-width: 320px) {
    .checkout-success-title {
      font-size: 15px;
    }
    .checkout-success-desc,
    .checkout-success-desc-notice {
      font-size: 12px;
    }
  }`, "",{"version":3,"sources":["webpack://./src/assets/css/index.css"],"names":[],"mappings":"AAEA;EACE,mEAAmE;EACnE,gBAAgB;EAChB,SAAS;EACT,sBAAsB;AACxB;EACE;IACE;MACE,cAAc;IAChB;EACF;EACA;IACE;MACE,cAAc;IAChB;EACF;;AAEF;EACE,SAAS;AACX;;AAEA;EAEE,sBAAsB;AACxB;;AAEA;EACE,2BAAc;EAAd,gBAAc;AAChB;;AAEA,kBAAkB;AAClB,WAAW,yBAAyB,EAAE;;AAEtC,qBAAqB;AACrB,aAAa,oCAAoC,EAAE;AACnD,WAAW,oCAAoC,EAAE;;AAEjD,eAAe;AACf,cAAc,yDAAyD;AACvE,SAAS,0BAA0B,CAAC;AACpC,SAAS,0BAA0B,CAAC;AACpC,UAAU,2BAA2B,EAAE;AACvC,UAAU,2BAA2B,EAAE;AACvC,SAAS,yBAAyB,CAAC;AACnC,SAAS,qBAAqB,EAAE;;AAEhC,uBAAuB;AACvB,QAAQ,uBAAuB,EAAE;AACjC,UAAU,uBAAuB,EAAE;AACnC,WAAW,sBAAuB,EAAvB,yBAAuB,EAAE;;AAEpC,mBAAmB;AACnB,cAAc,6BAA6B,EAAE;AAC7C,cAAc,6BAA6B,EAAE;AAC7C,SAAS,mBAAmB,EAAE;AAC9B,WAAW,mBAAmB,EAAE;;AAEhC,iBAAiB;AACjB,QAAQ,0BAA0B,EAAE;AACpC,QAAQ,0BAA0B,EAAE;AACpC,QAAQ,0BAA0B,EAAE;AACpC,QAAQ,0BAA0B,EAAE;AACpC,QAAQ,0BAA0B,EAAE;AACpC,SAAS,2BAA2B,EAAE;AACtC,SAAS,2BAA2B,EAAE;AACtC,SAAS,2BAA2B,EAAE;AACtC,SAAS,2BAA2B,EAAE;AACtC,SAAS,2BAA2B,EAAE;AACtC,SAAS,2BAA2B,EAAE;AACtC,SAAS,2BAA2B,EAAE;AACtC,SAAS,2BAA2B,EAAE;AACtC,SAAS,2BAA2B,EAAE;AACtC,SAAS,2BAA2B,EAAE;AACtC,SAAS,2BAA2B,EAAE;AACtC,SAAS,2BAA2B,EAAE;AACtC,SAAS,2BAA2B,EAAE;AACtC,QAAQ,4BAA4B,EAAE;AACtC,QAAQ,4BAA4B,EAAE;AACtC,SAAS,6BAA6B,EAAE;AACxC,SAAS,6BAA6B,EAAE;AACxC,SAAS,6BAA6B,EAAE;AACxC,SAAS,6BAA6B,EAAE;AACxC,QAAQ,6BAA6B,EAAE;AACvC,QAAQ,6BAA6B,EAAE;AACvC,SAAS,8BAA8B,EAAE;AACzC,SAAS,8BAA8B,EAAE;AACzC,SAAS,8BAA8B,EAAE;AACzC,SAAS,8BAA8B,EAAE;AACzC,SAAS,8BAA8B,EAAE;AACzC,SAAS,8BAA8B,EAAE;AACzC,SAAS,8BAA8B,EAAE;AACzC,SAAS,8BAA8B,EAAE;AACzC,SAAS,8BAA8B,EAAE;AACzC,SAAS,8BAA8B,EAAE;AACzC,SAAS,4BAA4B,EAAE;AACvC,SAAS,4BAA4B,EAAE;AACvC,SAAS,4BAA4B,EAAE;AACvC,SAAS,4BAA4B,EAAE;;AAEvC,kBAAkB;AAClB,SAAS,4BAA4B,EAAE;AACvC,QAAQ,2BAA2B,EAAE;AACrC,SAAS,8BAA8B,EAAE;AACzC,SAAS,8BAA8B,EAAE;AACzC,SAAS,+BAA+B,EAAE;AAC1C,SAAS,+BAA+B,EAAE;AAC1C,UAAU,gCAAgC,EAAE;AAC5C,UAAU,gCAAgC,EAAE;AAC5C,QAAQ,0BAA0B,EAAE;AACpC,SAAS,6BAA6B,EAAE;AACxC,SAAS,6BAA6B,EAAE;;AAExC,gBAAgB;AAChB;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;AACb;;AAEA,WAAW;AACX;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,sBAAsB;EACtB,gCAAa;EAAb,eAAa;EACb,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;EACE;IACE,yBAAyB;IACzB,WAAW;EACb;AACF,aAAa;AACb;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;EACE;IACE,wBAAwB;IACxB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;IACtB,WAAW;IACX,oBAAoB;EACtB;IACE;MACE;QACE,eAAe;MACjB;IACF;AACJ,QAAQ;AACR;EACE,sBAAsB;EACtB,uBAAwB;EAAxB,0BAAwB;AAC1B;AACA;;;EAGE,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;;AAEA,UAAU;AACV;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,8BAA8B;EAC9B,YAAY;AACd;EACE;IACE,eAAe;IACf,SAAS;IACT,QAAQ;IACR,wBAAwB;IACxB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,2CAA2C;IAC3C,sBAAsB;IACtB,yBAAyB;IAKzB,gCAAgC;EAClC;IACE;MACE,WAAW;MACX,YAAY;MACZ,gBAAoB;MAApB,sBAAoB;MACpB,UAAU;IACZ;IACA;MACE,WAAW;MACX,gBAAoB;MAApB,sBAAoB;MACpB,UAAU;IACZ;IACA;MACE,WAAW;MACX,gBAAoB;MAApB,sBAAoB;MACpB,UAAU;IACZ;IACA;MACE;QACE,yBAAyB;MAC3B;IACF;IACA;MACE;QACE,yBAAyB;MAC3B;IACF;IACA;MACE,WAAW;MACX,YAAY;MACZ,eAAe;MACf,sBAAsB;MACtB,gCAAgC;MAChC,YAAY;IACd;MACE;QACE,cAAc;QACd,YAAY;QACZ,eAAe;QACf,oBAAoB;QACpB,kBAAkB;QAClB,iBAAiB;QACjB,sBAAsB;QACtB,kBAAkB;QAClB,WAAW;MACb;IACF;MACE,YAAY;MACZ,gBAAgB;IAClB;IACA;MACE,yBAAyB;MACzB,gBAAgB;IAClB;IACA;MACE,eAAe;MACf,UAAU;MACV,SAAS;MACT,aAAa;IACf;MACE;;;QAGE,UAAU;QACV,SAAS;MACX;;AAEN,YAAY;AACZ;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;AACb;;AAEA,aAAa;AACb;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;AACb;;AAEA,YAAY;AACZ;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,8BAA8B;EAC9B,aAAa;AACf;AACA;EACE,eAAe;EACf,QAAQ;EACR,WAAW;EACX,cAAc;EACd,eAAe;EACf,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,eAAe;AACjB;EACE;IACE,cAAc;IACd,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,oBAAoB;EACtB;;AAEF,wBAAwB;AACxB;EACE,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,gFAA+E;AACjF;EACE;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;EACb;AACF;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;AACxB;EACE;;IAEE,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,iBAAiB;EACnB;EACA;;IAEE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;IACX,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;IACX,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,iBAAiB;EACnB;EACA;IACE,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,iBAAiB;EACnB;IACE;MACE,qBAAqB;MACrB,UAAU;MACV,gBAAgB;IAClB;IACA;;IAEA;IACA;MACE,aAAa;MACb,gBAAgB;IAClB;IACA;MACE,cAAc;MACd,gBAAgB;MAChB,eAAe;MACf,cAAc;MACd,oBAAoB;IACtB;AACJ,4BAA4B;AAC5B;EACE,cAAc;EACd,iBAAiB;AACnB;EACE;IACE,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;IACX,eAAe;EACjB;EACA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,kBAAkB;IAClB,WAAW;EACb;EACA;IACE,gBAAgB;IAChB,eAAe;IACf,WAAW;EACb;IACE;MACE,qBAAqB;MACrB,UAAU;MACV,gBAAgB;IAClB;IACA;;IAEA;;AAEJ,2BAA2B;AAC3B;EACE,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,WAAW;AACb;;AAEA,8BAA8B;AAC9B;EACE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA,mBAAmB;AACnB;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,kCAAkC;EAClC,kCAAkC;EAClC,qBAAgB;EAAhB,gBAAgB;EAChB,kBAAa;EAAb,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;EACE;IACE,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IACtB,WAAW;EACb;;AAEF,qBAAqB;AACrB;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;EACE;IACE,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,iBAAiB;EACnB;EACA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,eAAe;IACf,eAAe;IACf,WAAW;EACb;IACE;MACE,cAAc;MACd,eAAe;MACf,gBAAgB;MAChB,kBAAkB;MAClB,kBAAkB;IACpB;IACA;MACE,cAAc;MACd,eAAe;MACf,gBAAgB;MAChB,iBAAiB;IACnB;EACF;IACE,eAAe;IACf,eAAe;IACf,WAAW;IACX,iBAAiB;EACnB;IACE;MACE,qBAAqB;MACrB,UAAU;MACV,gBAAgB;IAClB;IACA;;IAEA;IACA;MACE,cAAc;MACd,eAAe;MACf,gBAAgB;MAChB,eAAe;MACf,eAAe;IACjB;;AAEJ,yBAAyB;AACzB;EACE,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;EACE;IACE,qBAAqB;IACrB,UAAU;IACV,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;;AAEF,yBAAyB;AACzB;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;AACxB;EACE;IACE,aAAa;IACb,eAAe;IACf,eAAe;IACf,WAAW;EACb;IACE;MACE,cAAc;MACd,eAAe;MACf,gBAAgB;MAChB,kBAAkB;MAClB,kBAAkB;IACpB;IACA;MACE,cAAc;MACd,eAAe;MACf,gBAAgB;MAChB,iBAAiB;IACnB;EACF;IACE,eAAe;IACf,eAAe;IACf,WAAW;IACX,iBAAiB;EACnB;IACE;MACE,qBAAqB;MACrB,UAAU;MACV,gBAAgB;IAClB;IACA;;IAEA;EACF;IACE,iBAAiB;EACnB;IACE;MACE,eAAe;MACf,gBAAgB;IAClB;IACA;MACE,eAAe;MACf,gBAAgB;IAClB;;AAEJ,0BAA0B;AAC1B,sBAAsB;AACtB;;;;EAIE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;;EAEE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;AACb;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;EACE;IACE;MACE,eAAe;IACjB;IACA;;MAEE,eAAe;IACjB;EACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/earlyaccess/notosanskr.css\");\n\nhtml, body, #root {\n  font-family:'Noto Sans CJK KR', Noto Sans KR, sans-serif !important;\n  font-weight: 500;\n  margin: 0;\n  background-color: #fff;\n}\n  @media (max-width: 320px) {\n    html, body, #root {\n      font-size: 9px;\n    }\n  }\n  @media (max-width: 280px) {\n    html, body, #root {\n      font-size: 8px;\n    }\n  }\n\np {\n  margin: 0;\n}\n\n*, *::before, *::after {\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n}\n\n:focus-visible {\n  outline: unset;\n}\n\n/* const display */\n.d-block { display: block !important; }\n\n/* const background */\n.bc-yellow { background-color: #BD9A1D !important; }\n.bc-gray { background-color: #bdbdbd !important; }\n\n/* const font */\n.fw-default { font-family:'Noto Sans CJK KR', Noto Sans KR, sans-serif }\n.fs-12 { font-size: 12px !important;}\n.fs-13 { font-size: 13px !important;}\n.fw-500 { font-weight: 500 !important; }\n.fw-700 { font-weight: 700 !important; }\n.c-red { color: #ff0000 !important;}\n.ws-pl { white-space: pre-line; }\n\n/* const height/width */\n.h-40 { height: 40px !important; }\n.h-full { height: 100% !important; }\n.w-unset { width: unset !important; }\n\n/* const position */\n.p-relative { position: relative !important; }\n.p-absolute { position: absolute !important; }\n.top-6 { top: 6px !important; }\n.right-0 { right: 0 !important; }\n\n/* const margin */\n.mt-1 { margin-top: 1px !important; }\n.mt-4 { margin-top: 4px !important; }\n.mt-5 { margin-top: 5px !important; }\n.mt-8 { margin-top: 8px !important; }\n.mt-9 { margin-top: 9px !important; }\n.mt-10 { margin-top: 10px !important; }\n.mt-12 { margin-top: 12px !important; }\n.mt-15 { margin-top: 15px !important; }\n.mt-17 { margin-top: 17px !important; }\n.mt-18 { margin-top: 18px !important; }\n.mt-20 { margin-top: 20px !important; }\n.mt-24 { margin-top: 24px !important; }\n.mt-27 { margin-top: 27px !important; }\n.mt-28 { margin-top: 28px !important; }\n.mt-30 { margin-top: 30px !important; }\n.mt-35 { margin-top: 35px !important; }\n.mt-40 { margin-top: 40px !important; }\n.mt-52 { margin-top: 52px !important; }\n.mr-4 { margin-right: 4px !important; }\n.mr-8 { margin-right: 8px !important; }\n.mr-20 { margin-right: 20px !important; }\n.mr-23 { margin-right: 23px !important; }\n.mr-30 { margin-right: 30px !important; }\n.mr-50 { margin-right: 50px !important; }\n.mb-2 { margin-bottom: 2px !important; }\n.mb-8 { margin-bottom: 8px !important; }\n.mb-10 { margin-bottom: 10px !important; }\n.mb-12 { margin-bottom: 12px !important; }\n.mb-17 { margin-bottom: 17px !important; }\n.mb-18 { margin-bottom: 18px !important; }\n.mb-20 { margin-bottom: 20px !important; }\n.mb-25 { margin-bottom: 25px !important; }\n.mb-28 { margin-bottom: 28px !important; }\n.mb-35 { margin-bottom: 35px !important; }\n.mb-40 { margin-bottom: 40px !important; }\n.mb-60 { margin-bottom: 60px !important; }\n.ml-20 { margin-left: 20px !important; }\n.ml-23 { margin-left: 23px !important; }\n.ml-30 { margin-left: 30px !important; }\n.ml-50 { margin-left: 50px !important; }\n\n/* const padding */\n.pt-40 { padding-top: 40px !important; }\n.pr-0 { padding-right: 0 !important; }\n.pr-20 { padding-right: 20px !important; }\n.pr-30 { padding-right: 30px !important; }\n.pb-40 { padding-bottom: 40px !important; }\n.pb-78 { padding-bottom: 78px !important; }\n.pb-100 { padding-bottom: 100px !important; }\n.pb-120 { padding-bottom: 120px !important; }\n.pl-0 { padding-left: 0 !important; }\n.pl-20 { padding-left: 20px !important; }\n.pl-30 { padding-left: 30px !important; }\n\n/* const image */\nimg {\n  vertical-align: middle;\n  border-style: none;\n}\n\n/* commons component */\n.horizontal-line {\n  height: 1px;\n  background-color: #ebebeb;\n}\n.horizontal-box {\n  height: 10px;\n  background-color: #f4f4f4;\n}\nimg.resort-logo {\n  width: 83px;\n}\nimg.resort-sub-logo {\n  width: 100%;\n  max-width: 450px;\n}\nimg.tip-icon {\n  width: 14px;\n  height: 14px;\n  object-fit: contain;\n}\nimg.checkbox {\n  width: 18px;\n  height: 18px;\n}\nimg.arrow-right {\n  position: absolute;\n  right: 0;\n  width: 18px;\n  height: 18px;\n  object-fit: contain;\n}\nimg.close-button {\n  width: 24px;\n  height: 24px;\n  object-fit: contain;\n}\nimg.password-view {\n  width: 17px;\n  height: 17px;\n}\nimg.important-notice {\n  width: 22px;\n  height: 25px;\n}\nimg.resort-map {\n  width: 100%;\n}\nimg.search {\n  width: 13.67px;\n  height: 12.15px;\n}\nimg.info-notice {\n  width: 13px;\n  height: 11px;\n}\nimg.safari-setup {\n  width: 100%;\n}\n\n/* button */\nbutton.basic-button {\n  width: 100%;\n  height: 48px;\n  padding: 0;\n  background-color: #000;\n  border: unset;\n  border-radius: 8px;\n  font-size: 15px;\n  font-style: normal;\n  color: #fff;\n}\n  button.basic-button:disabled {\n    background-color: #f4f4f4;\n    color: #000;\n  }\n/* checkbox */\n.agree-checkbox-container {\n  display: flex;\n  position: relative;\n  line-height: 1;\n}\n  .agree-checkbox-container .agree-checkbox-text {\n    width: calc(100% - 50px);\n    font-size: 14px;\n    font-weight: 350;\n    font-style: normal;\n    line-height: 1.43;\n    letter-spacing: -0.4px;\n    color: #000;\n    word-break: keep-all;\n  }\n    @media (max-width: 320px) {\n      .agree-checkbox-container .agree-checkbox-text {\n        font-size: 11px;\n      }\n    }\n/* PDF */\n.react-pdf__Page__canvas {\n  width: 100% !important;\n  height: unset !important;\n}\n.react-pdf__Page__svg,\n.react-pdf__Page__svg > svg,\n.react-pdf__Page__textContent {\n  width: 100% !important;\n  height: 100% !important;\n}\n.react-pdf__Page {\n  border-bottom: 1px dotted;\n}\n\n/* modal */\n.modal {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: rgba(0, 0, 0, 0.6);\n  z-index: 998;\n}\n  .modal .modal-body {\n    position: fixed;\n    left: 50%;\n    top: 50%;\n    width: calc(100% - 40px);\n    max-height: 80%;\n    overflow: scroll;\n    /* height: 400px; */\n    /* margin: 0 20px 0; */\n    padding: 16px 20px;\n    border-radius: 24px;\n    box-shadow: 4px 4px 16px 0 rgb(0 0 0 / 10%);\n    background-color: #fff;\n    /* align-items: center; */\n    -webkit-transform: translate(-50%, -50%);\n    -moz-transform: translate(-50%, -50%);\n    -ms-transform: translate(-50%, -50%);\n    -o-transform: translate(-50%, -50%);\n    transform: translate(-50%, -50%);\n  }\n    .modal .modal-body.full {\n      width: 100%;\n      height: 100%;\n      border-radius: unset;\n      padding: 0;\n    }\n    .modal .modal-body.x-large {\n      height: 70%;\n      border-radius: unset;\n      padding: 0;\n    }\n    .modal .modal-body.large {\n      height: 60%;\n      border-radius: unset;\n      padding: 0;\n    }\n    @media (min-width: 550px) {\n      .modal .modal-body {\n        width: calc(100% - 248px);\n      }\n    }\n    @media (min-width: 720px) {\n      .modal .modal-body {\n        width: calc(100% - 356px);\n      }\n    }\n    .modal .modal-body .modal-title-container {\n      width: 100%;\n      height: 52px;\n      position: fixed;\n      background-color: #fff;\n      border-bottom: 1px solid #ebebeb;\n      z-index: 999;\n    }\n      .modal .modal-body .modal-title-container .modal-title {\n        display: block;\n        height: 52px;\n        font-size: 16px;\n        font-stretch: normal;\n        font-style: normal;\n        line-height: 52px;\n        letter-spacing: -0.4px;\n        text-align: center;\n        color: #000;\n      }\n    .modal .modal-body .modal-content-container {\n      height: 100%;\n      overflow: scroll;\n    }\n    .modal .modal-body.exist-title .modal-content-container {\n      height: calc(100% - 52px);\n      overflow: scroll;\n    }\n    .modal .modal-body .close-button-container {\n      position: fixed;\n      left: 18px;\n      top: 18px;\n      z-index: 1000;\n    }\n      .modal .modal-body.x-large .close-button-container,\n      .modal .modal-body.large .close-button-container,\n      .modal .modal-body.full .close-button-container {\n        left: 16px;\n        top: 14px;\n      }\n\n/* pc page */\n.on-pc-icon {\n  text-align: center;\n  font-size: 100px;\n  color: #faad14;\n}\n.on-pc-status-code {\n  display: block;\n  margin: 14px 0;\n  font-size: 22px;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.5;\n  letter-spacing: -0.4px;\n  text-align: center;\n  color: #000;\n}\n.on-pc-status-message {\n  display: block;\n  margin: 0 0 20px;\n  font-size: 16px;\n  font-weight: 300;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.43;\n  letter-spacing: -0.4px;\n  text-align: center;\n  word-break: keep-all;\n  color: #000;\n}\n\n/* 404 page */\n.not-found-icon {\n  text-align: center;\n  font-size: 100px;\n  color: #faad14;\n}\n.not-found-code {\n  display: block;\n  margin: 14px 0;\n  font-size: 22px;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.5;\n  letter-spacing: -0.4px;\n  text-align: center;\n  color: #000;\n}\n.not-found-message {\n  display: block;\n  margin: 0 0 20px;\n  font-size: 16px;\n  font-weight: 300;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.43;\n  letter-spacing: -0.4px;\n  text-align: center;\n  word-break: keep-all;\n  color: #000;\n}\n\n/* spinner */\n.spinner-container {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: rgba(0, 0, 0, 0.6);\n  z-index: 1999;\n}\n.spinner-container .spinner-text {\n  position: fixed;\n  top: 50%;\n  width: 100%;\n  color: #8fb0cf;\n  font-size: 16px;\n  z-index: 2000;\n  display: block;\n  text-align: center;\n}\n\n/* safari setup page */\n.safari-setup-title {\n  font-size: 15px;\n  font-weight: 500;\n  word-break: keep-all;\n  margin: 15px 0 0;\n}\n.safari-setup-description-title {\n  margin: 15px 0 0;\n  font-size: 15px;\n  font-weight: 700;\n  word-break: keep-all;\n}\n.safari-setup-description-content {\n  display: block;\n  font-size: 14px;\n  font-weight: 400;\n  word-break: keep-all;\n}\n.info-notice-container {\n  display: flex;\n  margin: 2px 0 0;\n}\n  .info-notice-container .info-notice-text {\n    display: block;\n    color: #AB8524;\n    font-size: 12px;\n    font-weight: 400;\n    word-break: keep-all;\n  }\n\n/* checkin before page */\n.result-background-container {\n  padding: 0 22px 0 18px;\n  text-align: center;\n}\n.checkin-before-title {\n  font-size: 24px;\n  font-style: normal;\n  color: #000;\n  margin: 0 0 20px;\n}\n.checkin-before-desc {\n  display: block;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  color: #000;\n  margin: 0 0 74px;\n}\n@media (max-width: 320px) {\n  .checkin-before-title {\n    font-size: 22px;\n  }\n  .checkin-before-desc {\n    font-size: 12px;\n  }\n}\n\n/* booking details page */\n.booking-background-container {\n  position: relative;\n  height: 216px;\n  width: 100%;\n  background: url('../images/resort-background.png') center top / cover no-repeat;\n}\n  .booking-background-container .resort-logo-container {\n    text-align: right;\n  }\n  .booking-background-container .welcome-message {\n    position: absolute;\n    bottom: 65px;\n    left: 21px;\n    font-size: 24px;\n    font-style: normal;\n    font-weight: 700;\n    color: #fff;\n  }\n.booking-details-card-container {\n  position: absolute;\n  top: 196px;\n  width: 100%;\n  padding: 20px 0 78px;\n  border-radius: 24px;\n  background-color: #fff;\n}\n  .booking-details-card-container .resort-name,\n  .inhouse-details-card-container .resort-name {\n    font-size: 18px;\n    font-style: normal;\n    line-height: 1.5;\n    color: #000;\n    padding: 0 30px 0;\n  }\n  .booking-details-card-container .roomtype-name,\n  .inhouse-details-card-container .roomtype-name {\n    display: block;\n    font-size: 14px;\n    font-weight: 400;\n    font-style: normal;\n    line-height: 1.43;\n    color: #000;\n    margin: 8px 0 0;\n    padding: 0 30px 0;\n  }\n  .booking-details-card-container .period {\n    display: block;\n    font-size: 12px;\n    font-weight: 350;\n    font-style: normal;\n    line-height: 1.43;\n    color: #000;\n    margin: 5px 0 0;\n    padding: 0 30px 0;\n  }\n  .booking-details-card-container .amount {\n    display: block;\n    font-size: 15px;\n    font-weight: 500;\n    text-align: right;\n    padding: 0 30px;\n    margin: 10px 0 0;\n  }\n  .booking-details-card-container .booking-details-title {\n    font-size: 16px;\n    font-style: normal;\n    color: #000;\n    padding: 0 30px 0;\n  }\n  .booking-details-card-container .booking-details-info {\n    margin: 10px 0 0;\n    font-size: 14px;\n    color: #000;\n    padding: 0 30px 0;\n  }\n    .booking-details-card-container .booking-details-info .booking-details-info-label {\n      display: inline-block;\n      width: 35%;\n      font-weight: 400;\n    }\n    .booking-details-card-container .booking-details-info .booking-details-info-value {\n\n    }\n    .booking-details-card-container .certification-notice {\n      display: flex;\n      margin: 8px 30px;\n    }\n    .booking-details-card-container .certification-notice .certification-notice-text {\n      display: block;\n      font-weight: 350;\n      font-size: 12px;\n      color: #FF4129;\n      word-break: keep-all;\n    }\n/* room select before page */\n.room-select-before-container {\n  margin: 0 30px;\n  padding: 47px 0 0;\n}\n  .room-select-before-container .resort-name {\n    font-size: 18px;\n    font-style: normal;\n    line-height: 1.5;\n    color: #000;\n  }\n  .room-select-before-container .roomtype-name {\n    display: block;\n    font-size: 14px;\n    font-weight: 400;\n    font-style: normal;\n    line-height: 1.43;\n    color: #000;\n    margin: 12px 0 0;\n  }\n  .room-select-before-container .period {\n    display: block;\n    font-size: 12px;\n    font-weight: 350;\n    font-style: normal;\n    line-height: 1.43;\n    color: #000;\n    margin: 7px 0 0;\n  }\n  .room-select-before-container .amount {\n    display: block;\n    font-size: 15px;\n    font-weight: 500;\n    text-align: right;\n    padding: 0 30px;\n    margin: 10px 0 0;\n  }\n  .room-select-before-container .booking-details-title {\n    font-size: 16px;\n    font-style: normal;\n    color: #000;\n  }\n  .room-select-before-container .booking-details-info {\n    margin: 20px 0 0;\n    font-size: 14px;\n    color: #000;\n  }\n    .room-select-before-container .booking-details-info .booking-details-info-label {\n      display: inline-block;\n      width: 35%;\n      font-weight: 400;\n    }\n    .room-select-before-container .booking-details-info .booking-details-info-value {\n\n    }\n\n/* terms of use list page */\n.terms-of-use-list-title {\n  margin: 0 0 6px;\n  font-size: 24px;\n  font-style: normal;\n  line-height: 1.42;\n  color: #000;\n}\n.terms-of-use-list-description {\n  display: block;\n  margin: 0 0 28px;\n  font-size: 13px;\n  font-weight: 350;\n  font-style: normal;\n  line-height: 1.38;\n  letter-spacing: -0.4px;\n  color: #000;\n}\n\n/* terms of use details page */\n.terms-of-use-details-title {\n  margin: 26px 30px 0;\n  font-size: 16px;\n}\n.terms-of-use-details-description {\n  display: block;\n  margin: 17px 30px 0;\n  font-size: 14px;\n  font-weight: 350;\n  white-space: break-spaces;\n  word-break: keep-all;\n}\n\n/* room list page */\n.room-list-title {\n  margin: 28px 30px 0 30px;\n  font-size: 18px;\n  font-weight: 500;\n}\n.map-zoom-in-button {\n  line-height: 10px;\n  margin-top: 4px;\n  text-align: center;\n}\n.map-zoom-in-text {\n  font-size: 12px;\n  font-weight: 400;\n}\n.room-list.roomtype-name {\n  margin: 18px 30px 0;\n  font-size: 18px;\n  font-weight: 700;\n}\n.room-list-description {\n  display: block;\n  margin: 0 30px;\n  font-size: 12px;\n  font-weight: 400;\n}\n.facility-list-title {\n  margin: 22px 30px 0;\n  font-size: 12px;\n  font-weight: 400;\n}\n.facility-list-data-container {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  grid-auto-rows: minmax(33px, auto);\n  column-gap: 13px;\n  row-gap: 10px;\n  margin: 10px 30px 0;\n  overflow-x: scroll;\n  white-space: nowrap;\n}\n  .facility-list-data-container .facility-list-value {\n    display: inline-block;\n    text-align: center;\n    border: 1px solid #000;\n    border-radius: 10px;\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 28px;\n  }\n  .facility-list-data-container .facility-list-value.selected {\n    background-color: #666;\n    color: #fff;\n  }\n\n/* room select page */\n.room-select-body-container {\n  width: 100%;\n  padding: 4px 0 9px;\n  border-radius: 24px;\n  background-color: #fff;\n}\n  .room-select-body-container .resort-name {\n    font-size: 18px;\n    font-style: normal;\n    line-height: 1.5;\n    color: #000;\n    padding: 0 20px 0;\n  }\n  .room-select-body-container .roomtype-name {\n    display: block;\n    font-size: 14px;\n    font-weight: 400;\n    font-style: normal;\n    line-height: 1.43;\n    color: #000;\n    margin: 12px 0 0;\n    padding: 0 20px 0;\n  }\n  .room-select-body-container .room-info {\n    display: flex;\n    padding: 0 20px;\n    margin: 4px 0 0;\n    color: #000;\n  }\n    .room-select-body-container .room-info .room-name {\n      display: block;\n      font-size: 24px;\n      font-weight: 500;\n      font-style: normal;\n      margin: 0 15px 0 0;\n    }\n    .room-select-body-container .room-info .building-name {\n      display: block;\n      font-size: 20px;\n      font-weight: 500;\n      line-height: 1.65;\n    }\n  .room-select-body-container .period-info {\n    margin: 3px 0 0;\n    font-size: 12px;\n    color: #000;\n    padding: 0 20px 0;\n  }\n    .room-select-body-container .period-info .period-info-label {\n      display: inline-block;\n      width: 20%;\n      font-weight: 350;\n    }\n    .room-select-body-container .period-info .period-info-value {\n\n    }\n    .room-select-body-container .amount {\n      display: block;\n      font-size: 15px;\n      font-weight: 500;\n      padding: 0 20px;\n      margin: 3px 0 0;\n    }\n\n/* payment success page */\n.payment-success-details-info {\n  margin: 5px 0 0 3px;\n  font-size: 12px;\n  color: #000;\n}\n  .payment-success-details-info .payment-success-details-info-label {\n    display: inline-block;\n    width: 25%;\n    font-weight: 700;\n  }\n  .payment-success-details-info .payment-success-details-info-value {\n    font-weight: 400;\n  }\n\n/* inhouse details page */\n.inhouse-details-card-container {\n  position: absolute;\n  top: 196px;\n  width: 100%;\n  padding: 30px 0 78px;\n  border-radius: 24px;\n  background-color: #fff;\n}\n  .inhouse-details-card-container .room-info {\n    display: flex;\n    padding: 0 30px;\n    margin: 4px 0 0;\n    color: #000;\n  }\n    .inhouse-details-card-container .room-info .room-name {\n      display: block;\n      font-size: 24px;\n      font-weight: 500;\n      font-style: normal;\n      margin: 0 15px 0 0;\n    }\n    .inhouse-details-card-container .room-info .building-name {\n      display: block;\n      font-size: 20px;\n      font-weight: 500;\n      line-height: 1.65;\n    }\n  .inhouse-details-card-container .period-info {\n    margin: 3px 0 0;\n    font-size: 12px;\n    color: #000;\n    padding: 0 30px 0;\n  }\n    .inhouse-details-card-container .period-info .period-info-label {\n      display: inline-block;\n      width: 20%;\n      font-weight: 350;\n    }\n    .inhouse-details-card-container .period-info .period-info-value {\n\n    }\n  .inhouse-details-card-container .pincode-info {\n    padding: 0 30px 0;\n  }\n    .inhouse-details-card-container .pincode-info .pincode-info-label {\n      font-size: 14px;\n      font-weight: 400;\n    }\n    .inhouse-details-card-container .pincode-info .pincode-info-value {\n      font-size: 20px;\n      font-weight: 700;\n    }\n\n/* checkout request page */\n/* payment fail page */\n.room-select-title,\n.checkout-request-title,\n.payment-success-title,\n.payment-fail-title {\n  font-size: 18px;\n  font-weight: 500;\n  margin: 2px 0 0;\n}\n.checkout-request-description,\n.payment-fail-description {\n  display: block;\n  font-size: 14px;\n  font-weight: 400;\n  color: #000;\n  margin: 20px 0 0;\n}\n.checkout-agree-checkbox-container {\n  margin: 10px 0 0;\n}\n.checkout-agree-checkbox-container .agree-checkbox-text {\n  font-size: 14px;\n  font-weight: 400;\n}\n\n/* checkout success page */\n.checkout-success-title {\n  font-size: 18px;\n  font-style: normal;\n  color: #000;\n  margin: 0 0 14px;\n}\n.checkout-success-desc {\n  display: block;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  word-break: keep-all;\n  color: #000;\n}\n.checkout-success-desc-notice {\n  display: block;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  color: #ff0000;\n}\n  @media (max-width: 320px) {\n    .checkout-success-title {\n      font-size: 15px;\n    }\n    .checkout-success-desc,\n    .checkout-success-desc-notice {\n      font-size: 12px;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
